import { DELETE, POST } from './API';

const PATH_ROOT = 'U013';

export type A02Output = {
  link: string;
};

export async function A02(userId: string, revision: number, linkToken: string): Promise<A02Output> {
  return await POST(`${PATH_ROOT}/link`, {
    user_id: userId,
    revision: revision,
    link_token: linkToken,
  });
}

export async function A03(userId: string, revision: number): Promise<void> {
  await DELETE(`${PATH_ROOT}/link`, {
    user_id: userId,
    revision: revision,
  });
}
